import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import { InstructorData, InstructorsList } from "@/builders/types/instructors";

import { id } from "./id";

const list = function (params?: FilterParams) {
  return api
    .get<InstructorsList>("instructors", { params })
    .then(({ data }) => data);
};

const post = function (data: InstructorData) {
  return api
    .post<{
      data: InstructorData;
    }>("instructors", data)
    .then(({ data }) => data);
};

export const instructors = {
  list,
  post,
  id,
};
